import { Link, useParams, useRouteError } from "react-router-dom";
import "./styles.css";
import GenericErrorDisplay from "../../../generic-error";
import { useContext } from "react";
import CongressesContext from "../context";
import { IMAGE_HOST } from "../../../../server/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGlobe,
  faLocationDot,
  faPeopleRoof,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faTiktok,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import STYLES_CONSTANTS from "../../../../styles";
import { externalRedirectUrl } from "../../../page-redirect";

const paramNames = { lc: "lc" };
export const path = `:${paramNames.lc}/`;

type LoaderType = Object;

export async function loader(): Promise<LoaderType> {
  return {};
}

export function Component() {
  const { lcs, congresses } = useContext(CongressesContext);
  const params = useParams();
  const lc = lcs.find((lc) => lc.id === params[paramNames.lc]);

  return (
    <section id="congresses">
      {congresses
        .filter((congress) => congress.lc === params[paramNames.lc])
        .map((congress) => (
          <div key={congress.id} className="congress">
            <div className="content-container">
              <div className="data">
                <div className="logo">
                  {congress.logo !== null ? (
                    <img
                      src={`${IMAGE_HOST}${congress.logo}`}
                      alt={congress.short_title}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faPeopleRoof}
                      color={STYLES_CONSTANTS["--color-fasmr-blue"]}
                      style={{ width: "100%", height: "100%" }}
                    />
                  )}
                </div>
                <div className="information">
                  <div className="label">
                    {congress.international ? "Internațional" : "Național"}
                  </div>
                  <h3>{congress.title}</h3>
                  <h4 className="date">
                    {congress.begin.getDate()}
                    {" " +
                      (congress.begin.getMonth() !== congress.end.getMonth()
                        ? new Intl.DateTimeFormat("ro-RO", {
                            month: "long",
                          }).format(congress.begin)
                        : "")}
                    {" " +
                      (congress.begin.getFullYear() !==
                      congress.end.getFullYear()
                        ? new Intl.DateTimeFormat("ro-RO", {
                            month: "long",
                          }).format(congress.begin)
                        : "")}
                    {" - "}
                    {congress.end.getDate()}{" "}
                    {new Intl.DateTimeFormat("ro-RO", {
                      month: "long",
                    }).format(congress.end)}
                    {" " + congress.end.getFullYear()}
                  </h4>
                  {congress.abstract_deadline && (
                    <div>
                      Deadline abstracte:{" "}
                      {congress.abstract_deadline.toLocaleDateString("ro-RO")}
                    </div>
                  )}
                  {congress.location && (
                    <b>
                      <FontAwesomeIcon icon={faLocationDot} color="red" />{" "}
                      {congress.location}
                    </b>
                  )}
                  {congress.description && (
                    <div className="description">{congress.description}</div>
                  )}
                  <div className="organizer">
                    <div>Organizat de:</div>
                    <img
                      src={`${IMAGE_HOST}${lc?.logo}`}
                      alt={lc?.name_short}
                    />
                  </div>
                </div>
              </div>
              <div className="gallery" />
              <div className="links">
                {congress.url && (
                  <Link
                    to={externalRedirectUrl(congress.url)}
                    className="primary button"
                  >
                    <FontAwesomeIcon icon={faGlobe} /> Website
                  </Link>
                )}
                {congress.facebook && (
                  <Link
                    to={externalRedirectUrl(congress.facebook)}
                    className="secondary button"
                  >
                    <FontAwesomeIcon icon={faFacebook} /> Facebook
                  </Link>
                )}
                {congress.instagram && (
                  <Link
                    to={externalRedirectUrl(congress.instagram)}
                    className="secondary button"
                  >
                    <FontAwesomeIcon icon={faInstagram} /> Instagram
                  </Link>
                )}
                {congress.youtube && (
                  <Link
                    to={externalRedirectUrl(congress.youtube)}
                    className="secondary button"
                  >
                    <FontAwesomeIcon icon={faYoutube} /> YouTube
                  </Link>
                )}
                {congress.tiktok && (
                  <Link
                    to={externalRedirectUrl(congress.tiktok)}
                    className="secondary button"
                  >
                    <FontAwesomeIcon icon={faTiktok} /> TikTok
                  </Link>
                )}
              </div>
            </div>
          </div>
        ))}
    </section>
  );
}
Component.displayName = "page-oportunitati-congresses-index";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-oportunitati-congresses-error-index";
